
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 383.6 383.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M255.8 112h-12c-4.4 0-8 3.6-8 8s3.6 8 8 8h12c4.4 0 8-3.6 8-8s-3.6-8-8-8z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M315.8 48h-48c0-26.4-21.6-48-48-48h-60c-26.4 0-48 21.6-48 48h-44c-22 0-40 18-40 40v16c0 12 9.2 22 20.8 23.6L69 347.2c2 20.8 19.2 36.4 40 36.4h165.6c20.8 0 38-15.6 40-36.4L335 127.6c11.6-1.6 20.8-11.6 20.8-23.6V88c0-22-18-40-40-40zm-156-32h60c17.6 0 32 14.4 32 32h-124c0-17.6 14.4-32 32-32zm180 88c0 4.4-3.6 8-8 8h-4c-4 0-7.6 3.2-8 7.2L298.6 346c-1.2 12.4-11.6 22-24 22H109c-12.4 0-22.8-9.6-24-22L64.6 128h143.2c4.4 0 8-3.6 8-8s-3.6-8-8-8h-156c-4.4 0-8-3.6-8-8V88c0-13.2 10.8-24 24-24h248c13.2 0 24 10.8 24 24v16z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M127.8 160c-4.4 0-8 3.6-8 8v152c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8zm64 0c-4.4 0-8 3.6-8 8v152c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8zm64 0c-4.4 0-8 3.6-8 8v152c0 4.4 3.6 8 8 8s8-3.6 8-8V168c0-4.4-3.6-8-8-8z"}})])
          )
        }
      }
    